module.exports = __webpack_public_path__ + "img/gsgl2.f85c237d.png";